import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Icons = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    '& > img:not(:last-of-type)': {
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);
